import {btn, comp, fieldset, form, tbar, TextField, textfield, win, Window} from "@intermesh/goui";
import {t} from "./util/Translate.js";
import {ServerApi} from "./util/ServerApi.js";
import {IfwInvalidator} from "./util/IfwInvalidator.js";
import {PortalConfig} from "./config";
import { CurrentSection } from "./services/CurrentSection.js";

export class PasswordResetDialog extends Window {
	private emailFld: TextField | undefined;
	private _lang: string|undefined;
	constructor() {
		super();
		this.title = `${t("Send username")} / ${t("Reset password")}`;
		this.modal = true;
		this.width = 600;
		this.maximizable = false;
		this.draggable = false;
		this.resizable = false;

		const f = form({
				flex: 1
			},
			fieldset({flex: 1},
				comp({
					tagName: "p",
					html: t("Please enter your registered e-mail address to receive a link to reset your password or send your username.")
				}),
				this.emailFld = textfield({
					label: t("Email"),
					name: "email",
					required: true,
					type: "email",
					listeners: {
						invalid: IfwInvalidator.setTranslatedEmailErrorMsg
					}
				})
			),
			tbar({},
				btn({
					text: t("Cancel"), handler: () => {
						this.close();
					}
				}),
				"->",
				btn({
					text: t("Send username"), handler: (_btn) => {
						this.handle(11);
					}
				}),
				btn({
					text: t("Reset password"), handler: (_btn) => {
						this.handle(12);
					}
				}),
			)
		);
		this.items.add(f);
	}

	/**
	 * @param mode 11 for send user name, 12 for password reset link
	 * @private
	 */
	private handle(mode: 11 | 12) {
		if (!this.emailFld?.isValid()) {
			this.emailFld?.focus();
			return;
		}
		const lang = sessionStorage.getItem("language") || this._lang || "NL";
		const params = {
			language: lang,
			tpl: mode,
			sectionId: null
		};
		if (CurrentSection.get()) {
			params.sectionId = CurrentSection.get().id;
		}

		const url = ServerApi.url("elearning/frontend/forgotpassword/" + this.emailFld.value, {}, false);
		this.mask();
		ServerApi.call(url, params, "POST").then((result) => {
			this.unmask();
			let msg, title;
			if (result.success) {
				msg = t("The e-mail was sent to your e-mail address.");
				title = mode === 11 ? t("Send username") : t("Reset password");
			} else {
				if (mode ===  11) {
					throw(t("We cannot send your username, because your email address is being used for multiple user accounts. Please contact your local contact person to receive your username."));
				} else {
					throw(t("We cannot reset your password, because your email address is being used for multiple user accounts. Please contact your local contact person to reset your password."));
				}
			}
			this.ifwAlert(msg, title).then(() => {this.unmask();this.close();});
		}).catch((reason) => {
			let msg: string = "";
			if (typeof reason === "string") {
				msg = reason;
			} else if (reason.status) {
				msg = reason.status === 429 ? t("You have logged too many requests. Please try again later.") : t(reason.statusText);
			} else {
				msg = t("Unknown error");
			}
			this.unmask();
			this.ifwAlert(msg, t("Reset password")).then(() => {this.unmask();this.close});
		})
	}

	private ifwAlert(msg: string, title?: string): Promise<void> {
		if(!title) {
			title = t("Success");
		}
		const w = win({
				modal: false,
				width: 450,
				height: 250,
				maximizable: false,
				draggable: false,
				resizable: false,
				title: title
			},

			comp({
				cls: "pad",
				text: msg
			}),
			tbar({cls: "ifw-bbar"}, "->", btn({
				text: t("Continue"), handler: () => {
					w.close();
				}
			})));
		return new Promise((resolve) => {
			w.on("close", () => resolve());
			w.show();
		});
	}

	public set lang(v: string) {
		this._lang = v;
	}
}